export const version = 'kunde-v1.20.0-SNAPSHOT-05a51330d0dbf3c8b8dd524e7a97ea354bddbd96';